import {
  CHANGE_VIDEO_PLAYER,
  LOAD_PLAYLISTS_PLAYER,
  LOAD_STATUS_PLAYER,
} from '../actions/types'

const createPlaylists = ({
  product: {
    courses: {
        sections,
      },
  },
}) => {
  let list = []
  sections.map(({ lectures }, section) =>
    lectures.map(({ videoImg, videoURL, title }, lecture) => {
      return list.push({
        title,
        file: videoURL,
        image: videoImg,
        section,
        lecture,
      })
    })
  )
  return list
}


const checkIsLoading = (status) => {
  switch (status) {
    case 'loading':
      return true
    case 'ready':
    case 'play':
    case 'destroyed':
      return false
    default:
      return false
  }
}

const initialState = {
  currentPlaying: {
    section: 0,
    lecture: 0,
  },
  status: 'destroyed',
  playlists: [],
  isLoading: false,
}


const Player = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_VIDEO_PLAYER:
      return {
        ...state,
        currentPlaying: {
          courseName: action.data.slugName,
          section: action.data.indexSection,
          lecture: action.data.indexLecture,
        },
        status: 'loading',
        isLoading: true,
      }
    case LOAD_PLAYLISTS_PLAYER:
      {
        return {
          ...state,
          playlists: createPlaylists(action.data),
          status: 'ready',
          isLoading: false,
        }
      }
    case LOAD_STATUS_PLAYER:
      return {
        ...state,
        status: action.data,
        isLoading: checkIsLoading(action.data),
      }
    default:
      return state
  }
}

export default Player



// WEBPACK FOOTER //
// ./src/reducers/player.js